import React, { Component, useEffect } from "react"
import {
  Sidebar,
  Menu,
  Button,
  Confirm,
  Icon,
  Breadcrumb,
  Card,
  Input,
  Form,
  Select,
  Modal,
  Header,
  Loader,
} from "semantic-ui-react"
import "../app/styles/treeMenuStyles.css"
import {
  Switch,
  Route,
  withRouter,
  BrowserRouter as Router,
  Link,
} from "react-router-dom"
import "./css/StoragePage.css"
import { connect } from "react-redux"
import { getProducts, getAllFilters, setCategory } from "../ducks/products"
import { apiGet, apiPost } from "../utils/apiConnector"
import ProductPage from "./ProductPage"
import ModalComponent from "../components/ModalComponent"
import Pagination from "../components/Pagination"

import {
  getImagesApi,
  getProductApi,
  storageSearchApi,
  storageSearchSubmitApi,
} from "../config/apiUrls"
import { withTranslation } from "react-i18next"

const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
const sortTypes = ["name", "barcode", "purchaseprice", "saleprice", "remainder"]

function flatArr(toFlatArr, flattedArr = []) {
  toFlatArr.map((el) => {
    if (el.nodes) {
      flatArr(el.nodes, flattedArr)
      // delete el.nodes
      flattedArr.push(el)
    } else {
      flattedArr.push(el)
    }
  })
  return flattedArr
}

@withTranslation()
@withRouter
@connect(
  (state) => ({
    products: state.products,
    profile: state.profile,
    filters: state.products.filters,
  }),
  (dispatch) => ({
    getData: () => dispatch(getProducts()),
    setCategory: (parentId, name) => dispatch(setCategory(parentId, name)),
  }),
)
class StoragePage extends Component {
  state = {
    products: [],
    modalState: false,
    stockId: null,
    confirmState: false,
    modalSettings: false,
    visible: true,
    media: window.innerWidth < 600,
    currentMenu: [],
    menuChildren: [],
    menuItems: [],
    constChildren: [],
    search: "",
    searchPreResult: [],
    preHidden: false,
    categoryId: 0,
    pages: 4,
    inputCount: 20,
    countOnPage: 20,
    page: 1,
    searchState: false,
    count: 0,
    sortValue: "name",
    sortState: false,
    filters: [],
    filtersChecked: [],
    addCategoryModal: false,
    addCategoryParent: -1,
    addCategoryName: "",
    sortBy: "",
    properties: [],
    sortDirection: "",
  }

  open = () => this.setState({ confirmState: true })
  close = () => this.setState({ confirmState: false })

  handleSort = (ev, data) => {
    this.setState({ sortValue: data.value })
  }

  componentDidMount() {
    this.props.getData()
  }

  handleResize = () => {
    let media = window.innerWidth < 600
    this.setState({ media })
    if (!media) {
      this.setState({ visible: true })
    }
  }

  setProperties = () => {
    const filtersChecked = [...this.state.filtersChecked]
    const result = []
    filtersChecked.map((el) => {
      const y = { propertyId: el.propertyId, values: [] }
      let b = false
      el.values.map((q) => {
        if (q.checked) {
          y.values.push(q.value)
          b = true
        }
      })
      if (b) {
        result.push(y)
      }
    })
    return result
  }

  getProduct(id) {
    this.setState({ products: [], categoryId: id })
    const data = { categoryId: id + "", page: 1, count: this.state.countOnPage }
    if (this.state.properties.length) {
      data.properties = [...this.state.properties]
    }
    if (this.state.sortBy && this.state.sortDirection) {
      data.sort = this.state.sortBy + " " + this.state.sortDirection
    }
    if (this.setProperties().length) {
      data.properties = this.setProperties()
    }
    apiPost(getProductApi, JSON.stringify(data))
      .onOk((res) => {
        if (!data.properties) {
          this.setState({
            filters: res.data.response.properties,
            filtersChecked: res.data.response.properties
              ? res.data.response.properties.map((el) => {
                  const y = {}
                  y.propertyId = el.propertyId
                  y.name = el.name
                  y.values = el.values.map((q) => ({
                    value: q,
                    checked: false,
                  }))
                  return y
                })
              : [],
          })
        }
        this.setState({
          products: res.data.response.products,
          pages: res.data.response.pages,
          sortState: true,
        })
      })
      .start()
  }

  searchSubmit = (text, count) => {
    if (text) {
      const storeId = this.props.profile.currentStore.id
      apiGet(storageSearchSubmitApi, {
        storeID: storeId,
        search: text,
        page: this.state.page,
        count: count || this.state.countOnPage,
      })
        .onOk((res) => {
          this.setState({
            products: res.data.response.products,
            pages: res.data.response.pages,
            searchState: true,
            count: res.data.response.count,
          })
          this.setState({ searchPreResult: [] })
        })
        .start()
    } else {
      this.setState({ searchPreResult: [] })
    }
  }

  getProductSetPageCount(count) {
    this.setState({ products: [], categoryId: this.state.categoryId })
    const data = {
      categoryId: this.state.categoryId + "",
      page: 1,
      count: count,
    }
    if (this.state.properties.length) {
      data.properties = [...this.state.properties]
    }
    if (this.state.sortBy && this.state.sortDirection) {
      data.sort = this.state.sortBy + " " + this.state.sortDirection
    }
    if (this.setProperties.length) {
      data.properties = [...this.state.properties]
    }
    apiPost(getProductApi, JSON.stringify(data))
      .onOk((res) => {
        this.setState({
          products: res.data.response.products,
          pages: res.data.response.pages,
        })
      })
      .start()
  }

  onPageSelectGetProduct = (id, page) => {
    this.setState({ products: [] })
    const data = {
      categoryId: id + "",
      page: page,
      count: this.state.countOnPage,
    }
    if (this.state.properties.length) {
      data.properties = [...this.state.properties]
    }
    if (this.state.sortBy && this.state.sortDirection) {
      data.sort = this.state.sortBy + " " + this.state.sortDirection
    }
    if (this.setProperties.length) {
      data.properties = [...this.state.properties]
    }
    apiPost(getProductApi, JSON.stringify(data))
      .onOk((res) => {
        this.setState({ products: res.data.response.products })
      })
      .start()
  }

  onPageSelectGetSearchProduct = (text, page) => {
    if (text) {
      const storeId = this.props.profile.currentStore.id
      apiGet(storageSearchSubmitApi, {
        storeID: storeId,
        search: text,
        page: page || this.state.page,
        count: this.state.countOnPage,
      })
        .onOk((res) => {
          this.setState({
            products: res.data.response.products,
            pages: res.data.response.pages,
            searchState: true,
            count: res.data.response.count,
          })
          this.setState({ searchPreResult: [] })
        })
        .start()
    } else {
      this.setState({ searchPreResult: [] })
    }
  }

  onPageSelect = (page) => {
    this.setState({ page: page })
    if (this.state.searchState) {
      this.setState({ page: page })
      this.onPageSelectGetSearchProduct(this.state.search, page)
    } else {
      this.onPageSelectGetProduct(this.state.categoryId, page)
    }
  }

  openProduct = (stockId, settings) => {
    if (settings) {
      this.setState({ modalSettings: true })
    } else this.setState({ modalSettings: false })
    this.setState({ stockId })
    this.setState({ modalState: true })
  }

  setMenu = (el) => {
    // shit code
    const currentMenu = [...this.state.currentMenu]
    const menuItems = [...this.state.menuItems]
    if (currentMenu.length === 0) {
      currentMenu.push(el)
      menuItems.push(el)
      this.setState({ currentMenu: currentMenu, menuItems: menuItems })
    } else if (el.parentId === 0) {
      menuItems.push(el)
      this.setState({ currentMenu: [el], menuItems: menuItems })
    } else {
      let y = menuItems.filter((q) => q.key === el.parentId)[0]
      const way = []
      way.unshift(el)
      if (y) {
        while (y) {
          way.unshift(y)
          y = menuItems.filter((q) => q.key === y.parentId)[0]
        }
        menuItems.push(el)
        this.setState({ currentMenu: way, menuItems: menuItems })
      }
    }
  }

  getCategories = (el) => {
    return el.nodes ? (
      <>
        <div
          className="menu-item"
          id={el.key}
          onClick={(e) => {
            this.setMenu(el)
            this.setCategories(e)
            this.setState({
              menuChildren: el.nodes,
              products: [],
              constChildren: el.nodes,
              sortState: false,
            })
          }}
          onMouseOver={() =>
            this.setState({
              menuChildren: el.nodes,
              products: [],
              sortState: false,
            })
          }
          onMouseOut={() => this.setState({ menuChildren: [] })}
        >
          {el.label + (el.nodes ? " +" : "")}
        </div>
        <div
          className="panel "
          style={{
            display: "none",
            paddingLeft: 20,
          }}
        >
          {el.nodes.map((q) => this.getCategories(q))}
          <div
            className="menu-item"
            onClick={() => {
              this.setState({
                addCategoryModal: true,
                addCategoryParent: el.key,
              })
            }}
          >
            {"Добавить категорию"}
          </div>
        </div>
      </>
    ) : (
      <div
        className="menu-item"
        id={el.key}
        key={el.key}
        onClick={() => {
          this.setMenu(el)
          this.getProduct(el.key)
          this.setState({ menuChildren: [] })
          this.setState({ constChildren: [] })
          if (this.state.media) this.setState({ visible: false })
          this.setState({ visible: false })
        }}
        onMouseOver={() => this.setState({ menuChildren: [] })}
      >
        {el.label}
      </div>
    )
  }

  setCategories = (e) => {
    this.open = { open: true }
    this.setState({ u: true })
    let a = e.target
    a.classList.toggle("active")
    if (~a.childNodes[0].nodeValue.indexOf("+")) {
      let l = a.childNodes[0].nodeValue.split(" ").length
      a.innerText =
        a.childNodes[0].nodeValue
          .split(" ")
          .slice(0, l - 1)
          .join() + " -"
    } else if (~a.childNodes[0].nodeValue.indexOf("-")) {
      let l = a.childNodes[0].nodeValue.split(" ").length
      a.innerText =
        a.childNodes[0].nodeValue
          .split(" ")
          .slice(0, l - 1)
          .join() + " +"
    }
    let panel = a.nextElementSibling
    if (panel) {
      if (panel.style.display === "block") {
        panel.style.display = "none"
      } else {
        panel.style.display = "block"
      }
    }
  }

  search = (text, submit) => {
    if (text) {
      const storeId = this.props.profile.currentStore.id
      apiGet(storageSearchApi, {
        storeID: storeId,
        search: text,
      })
        .onOk((res) => {
          if (submit) {
            this.setState({
              products: res.data.response,
            })
            this.setState({ searchPreResult: [] })
          } else {
            this.setState({ searchPreResult: res.data.response })
          }
        })
        .start()
    } else {
      this.setState({ searchPreResult: [] })
    }
  }

  render() {
    const h = 50
    const media = this.state.media
    const { data } = this.props.products
    const { menuChildren, sortValue, products } = this.state

    let sortedProducts = []
    if (sortValue === "name") {
      sortedProducts = products.sort((a, b) => a.name.localeCompare(b.name))
    }

    if (sortValue === "price") {
      sortedProducts = products.sort((a, b) => a.salePrice - b.salePrice)
    }

    const sidebarPadding =
      window.innerWidth > 600 && !this.state.visible ? 0 : 260
    const { t } = this.props
    return (
      <div
        style={{ height: "max-content" }}
        onClick={(e) => {
          if (e.target.className === "preHiddenEditClass") {
            this.setState({ preHidden: false })
          } else {
            this.setState({ preHidden: true })
          }
        }}
      >
        <Router>
          <div
            className="category-header"
            style={{
              height: h,
              position: "relative",
              zIndex: 100,
              backgroundColor: "white",
              margin: "-1em -1em 0 -1em",
              padding: "1em 1em",
            }}
          >
            <Button
              onClick={() => this.setState({ visible: !this.state.visible })}
              positive
            >
              {!this.state.visible
                ? t("showCategorySidebar")
                : t("hideCategorySidebar")}
            </Button>

            <h1 className="storage-page-title">{t("storagePage")} </h1>

            <Form onSubmit={() => this.searchSubmit(this.state.search)}>
              <Form.Field
                style={{
                  display: "flex",
                  width: 300,
                  margin: 0,
                }}
              >
                <Input
                  className="editable-table-holder-search"
                  placeholder={t("search")}
                  onChange={(e, d) => {
                    this.setState({ search: d.value, preHidden: false })
                    this.search(d.value, false)
                  }}
                />
                <Button positive>
                  <Icon style={{ margin: 0 }} name="search" />
                </Button>
              </Form.Field>
              <div
                style={{
                  position: "absolute",
                  backgroundColor: "white",
                  border: "1px solid lightgray",
                  borderRadius: 5,
                  margin: 0,
                  width: 300,
                  display: this.state.preHidden ? "none" : "block",
                }}
              >
                {this.state.searchPreResult.map((el) => {
                  return (
                    <>
                      <div
                        className="preHiddenEditClass"
                        onClick={({ target }) => {
                          document.querySelector(".box")
                          this.setState({ searchPreResult: [] })
                          target.classList.contains("btn-edit-product")
                            ? this.openProduct(el.stockId, true)
                            : this.openProduct(el.stockId, false)
                          if (event.target.closest(".box")) return
                          this.setState({ preHidden: true })
                        }}
                      >
                        {el.name + " (" + el.categoryName + ")"}
                      </div>
                    </>
                  )
                })}
              </div>
            </Form>
          </div>
          <div style={{ marginTop: h }}>
            <Sidebar
              // direction="top"
              as={Menu}
              visible={this.state.visible}
              // horizontal
              vertical
              animation="push"
              className="sidebar-css"
              style={{
                width: media ? screen.width : 260,
              }}
            >
              {/* <TreeMenu
            data={data}
            onClickItem={(menuData) => {
              let newArr = flatArr(data)
              this.setState({ currentMenu: menuData.label })
              newArr.forEach((arr) => {
                if (menuData.label === arr.label) {
                  if (arr.nodes) {
                    this.setState({ menuChildren: arr.nodes, products: [] })
                  } else this.setState({ menuChildren: [] })
                  if (menuData.parentId !== 0 && !menuData.nodes) {
                    this.getProduct(arr.key)
                    if (media) this.setState({ visible: false })
                  }
                }
              })
            }}
          /> */}
              {this.props.products.isLoading ? (
                <Loader active={this.props.products.isLoading} />
              ) : (
                <>
                  <div style={{ marginTop: h }}>
                    {data.map((el) => this.getCategories(el))}
                  </div>
                  <div
                    className="menu-item"
                    onClick={() => {
                      this.setState({
                        addCategoryParent: 0,
                        addCategoryModal: true,
                      })
                    }}
                  >
                    {"Добавить категорию"}
                  </div>
                </>
              )}
            </Sidebar>
          </div>
          {
            // Pointer
          }
          {this.state.addCategoryModal ? (
            <Modal
              open={this.state.addCategoryModal}
              onClose={() => {
                this.setState({
                  addCategoryModal: false,
                  addCategoryParent: -1,
                  addCategoryName: "",
                })
              }}
              size="small"
            >
              <Header content={"Добавить категорию"} />
              <Modal.Content>
                <Input
                  onChange={(e, d) => {
                    this.setState({ addCategoryName: d.value })
                  }}
                />
                <Button
                  content={"Добавить"}
                  positive
                  onClick={() => {
                    this.props.setCategory(
                      this.state.addCategoryParent,
                      this.state.addCategoryName,
                    )
                    this.setState({
                      addCategoryParent: -1,
                      addCategoryName: "",
                      addCategoryModal: false,
                    })
                  }}
                />
                <Button content={"Отмена"} />
              </Modal.Content>
            </Modal>
          ) : (
            <></>
          )}
          {iOS ? (
            <div
              style={{
                backgroundColor: "rgb(255,255,255,0)",
                position: "fixed",
                top: 0,
                left: 0,
                width: 30,
                zIndex: 9,
                bottom: 0,
                display: media ? "flex" : "none",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                style={{ width: 80, fontSize: 8 }}
                onTouchStart={() => this.setState({ sidebarClick: true })}
                onTouchMove={() => {
                  if (this.state.sidebarClick) {
                    this.setState({ visible: true, sidebarClick: false })
                  }
                }}
              >
                {"->"}
              </Button>
            </div>
          ) : (
            <div
              style={{
                backgroundColor: "rgb(255,255,255,0)",
                position: "fixed",
                top: 0,
                left: 0,
                width: 30,
                zIndex: 9,
                bottom: 0,
                display: media ? "flex" : "none",
              }}
              onTouchStart={() => this.setState({ sidebarClick: true })}
              onTouchMove={() => {
                if (this.state.sidebarClick) {
                  this.setState({ visible: true, sidebarClick: false })
                }
              }}
            ></div>
          )}
          <div
            style={{
              backgroundColor: "rgb(255,255,255,0)",
              position: "fixed",
              top: 0,
              right: 0,
              width: 30,
              zIndex: 99,
              bottom: 0,
              overflowX: "auto",
              display: media ? "flex" : "none",
            }}
            onTouchStart={() => this.setState({ sidebarClick: true })}
            onTouchMove={() => {
              if (this.state.sidebarClick) {
                this.setState({ visible: false, sidebarClick: false })
              }
            }}
          ></div>

          <div style={{ paddingLeft: media ? 0 : sidebarPadding }}>
            <h2
              style={{
                textAlign: "center",
                fontSize: 20,
                margin: "20px 0px 20px 0",
              }}
            >
              {this.state.searchState ? (
                <p>
                  {t("Found") + "" + this.state.count + " " + t("of goods")}
                </p>
              ) : this.state.currentMenu.length ? (
                <div className="breadcrumb-wrap">
                  {this.state.currentMenu.map((el) => (
                    <Breadcrumb key={el.key}>
                      <Breadcrumb.Divider icon="right chevron" />
                      <span
                        onClick={() => {
                          let q = document.getElementById(el.key)
                          if (q) {
                            document.getElementById(el.key).click()
                          }
                        }}
                      >
                        {el.label}
                      </span>
                    </Breadcrumb>
                  ))}
                </div>
              ) : (
                <p>{t("Select a category")}</p>
              )}
            </h2>
            <div className="menu-children-container">
              {this.state.products.length ? (
                <>
                  <div>
                    <Pagination
                      max={this.state.pages}
                      count={this.state.pages}
                      current={this.state.page}
                      onSelect={this.onPageSelect}
                    />
                  </div>

                  <div>
                    <p style={{ margin: "0 5px 0 0" }}>
                      {" "}
                      Количество на странице
                    </p>
                    <Select
                      width={50}
                      placeholder="Количество на странице"
                      value={this.state.inputCount}
                      style={{
                        fontWeight: 100,
                        width: 60,
                        minWidth: "unset",
                      }}
                      onChange={(e, d) => {
                        this.setState({ inputCount: d.value }, () => {
                          this.setState({ countOnPage: this.state.inputCount })

                          if (!this.state.searchState) {
                            this.getProductSetPageCount(this.state.inputCount)
                          } else {
                            this.searchSubmit(
                              this.state.search,
                              this.state.inputCount,
                            )
                          }
                        })
                      }}
                      options={[
                        {
                          value: 10,
                          text: 10,
                        },
                        {
                          value: 20,
                          text: 20,
                        },
                        {
                          value: 50,
                          text: 50,
                        },
                      ]}
                    />
                  </div>
                </>
              ) : (
                <></>
              )}

              {this.state.sortState && false && (
                <Select
                  placeholder="Сортировка"
                  value={this.state.sortValue}
                  onChange={this.handleSort}
                  style={{ fontWeight: 100 }}
                  options={[
                    {
                      value: "name",
                      text: "По названию",
                    },
                    {
                      value: "price",
                      text: "По цене",
                    },
                  ]}
                />
              )}

              {(menuChildren.length
                ? menuChildren
                : this.state.constChildren
              ).map((menu) => {
                return (
                  <Card
                    key={menu.key}
                    style={{ width: "max-content" }}
                    header={
                      <h3
                        className="card-header-link-hover"
                        onClick={() => {
                          let q = document.getElementById(menu.key)
                          if (q) {
                            if (
                              this.state.currentMenu.filter(
                                (a) => a.key === menu.key,
                              ).length === 0
                            ) {
                              document.getElementById(menu.key).click()
                            }
                          }
                        }}
                      >
                        {menu.label}
                      </h3>
                    }
                    description={
                      menu.nodes ? (
                        <div
                          style={{
                            /* width:
                              menu.nodes.length > 4
                                ? "100%"
                                : menu.nodes.length * 25 + "%", */
                            /* width:
                              (menu.nodes.length - (menu.nodes.length % 5)) *
                                30 +
                              20,
                            height:
                              (menu.nodes.length / 5 < 1
                                ? menu.nodes.length % 5
                                : 5) *
                                30 +
                              300, */
                            display: "block",
                          }}
                        >
                          {menu.nodes.map((el, i) => (
                            <>
                              <span
                                style={{
                                  textAlign: "start",
                                  width: "25%",
                                  display: "inline-block",
                                  /* position: "absolute",
                                  top:
                                    50 +
                                    (i % 5) *
                                      (el.label.split(" ").filter((q) => {
                                        return q.length > 4
                                      }).length +
                                        25),
                                  left: 10 + (i - (i % 5)) * 30, */
                                }}
                                onClick={() => {
                                  let w = document.getElementById(menu.key)
                                  if (w) {
                                    if (
                                      this.state.currentMenu.filter(
                                        (a) => a.key === menu.key,
                                      ).length === 0
                                    ) {
                                      document.getElementById(menu.key).click()
                                    }
                                  }
                                  setTimeout(() => {
                                    let q = document.getElementById(el.key)
                                    if (q) {
                                      document.getElementById(el.key).click()
                                    }
                                  }, 100)
                                }}
                              >
                                <p
                                  className="card-header-link-hover"
                                  style={
                                    {
                                      // width: "25%",
                                      // marginLeft: (i - (i % 5)) * 7 + "%",
                                    }
                                  }
                                >
                                  {el.label}
                                </p>
                              </span>
                              {/* i % 4 === 3 ? <tr></tr> : "" */}
                            </>
                          ))}
                        </div>
                      ) : (
                        ""
                      )
                    }
                  />
                )
              })}
            </div>
            <div>
              {sortedProducts.length ? (
                <>
                  {this.state.filtersChecked.map((el) => {
                    return (
                      <>
                        <div>
                          <span>{el.name}</span>
                          <div>
                            {el.values.map((q) => (
                              <>
                                <span>{q.value}</span>
                                <input
                                  type="checkbox"
                                  checked={q.checked}
                                  onChange={() => {
                                    const l = [...this.state.filtersChecked]
                                    this.setState({
                                      filtersChecked: l.map((eel) => {
                                        const u = { ...eel }
                                        u.values = eel.values.map((w) => {
                                          const y = {
                                            value: w.value,
                                            checked: w.checked,
                                          }
                                          if (w.value === q.value) {
                                            y.checked = !w.checked
                                          }
                                          return y
                                        })
                                        return u
                                      }),
                                    })
                                    return true
                                  }}
                                />
                              </>
                            ))}
                          </div>
                          <p></p>
                        </div>
                      </>
                    )
                  })}
                  <p>Сортировать по: </p>
                  <span>Убыванию</span>
                  <Input
                    type="checkbox"
                    checked={this.state.sortDirection === "desc"}
                    onClick={() => {
                      this.setState({ sortDirection: "desc" })
                    }}
                  />
                  <span>Возрастанию</span>
                  <Input
                    type="checkbox"
                    checked={this.state.sortDirection === "asc"}
                    onClick={() => {
                      this.setState({ sortDirection: "asc" })
                    }}
                  />
                  {sortTypes.map((el) => (
                    <>
                      <div>
                        <span>{t(el)}</span>
                        <Input
                          type="checkbox"
                          checked={el === this.state.sortBy}
                          onClick={() => {
                            this.setState({ sortBy: el })
                          }}
                        />
                      </div>
                    </>
                  ))}
                  <Button
                    content="update"
                    onClick={() => this.getProduct(this.state.categoryId)}
                  />
                </>
              ) : (
                <></>
              )}
            </div>
            <div className="products-container">
              {sortedProducts.map((product) => {
                return (
                  <div
                    onClick={({ target }) => {
                      target.classList.contains("btn-edit-product")
                        ? this.openProduct(product.stockId, true)
                        : this.openProduct(product.stockId, false)
                    }}
                    key={product.stockId}
                    style={{ margin: "5px 0" }}
                  >
                    <Card className="product product-container">
                      <Icon
                        name="pencil alternate"
                        className="btn-edit-product"
                        size="large"
                        color="grey"
                        title="Редактировать"
                      />
                      <img src={getImagesApi + product.imageName} />
                      <div className="product-main-info">
                        <p>
                          <strong>{product.name}</strong>{" "}
                        </p>
                        <div className="product-main-description">
                          <p
                            style={{
                              flexBasis: "100%",
                              color: "gray",
                              fontZize: 12,
                              marginTop: -11,
                            }}
                          >
                            {"Штрих-код: "} {product.barcode}
                          </p>
                          <p>
                            {"Цена закупа: "} <br />
                            {product.purchasePrice}
                          </p>
                          <p>
                            {"Цена продажи: "} <br />
                            {product.salePrice}
                          </p>
                          <p
                            style={{
                              margin: "0 0 0 auto",
                              textAlign: "right",
                              color: "gray",
                              fontSize: 12,
                            }}
                          >
                            {"Остаток: " +
                              product.remainder +
                              " " +
                              product.shortName}
                          </p>
                        </div>
                      </div>

                      {/* <div>
                      <Button icon>
                        <Icon name="pencil alternate" />
                        Изменить
                      </Button>
                    </div> */}
                    </Card>
                  </div>
                )
              })}
              {
                <ModalComponent
                  modalState={this.state.modalState}
                  ModalContent={ProductPage}
                  closeAction={() =>
                    this.setState({ modalState: false, stockId: null })
                  }
                  configs={{
                    for: "ProductPage",
                    stockId: this.state.stockId,
                    settings: this.state.modalSettings,
                  }}
                />
              }
            </div>
            <Confirm
              open={this.state.confirmState}
              onCancel={this.close}
              onConfirm={this.close}
              className="confirm-modal"
            />
          </div>
          <Switch></Switch>
        </Router>
      </div>
    )
  }
}

export default withRouter(StoragePage)
